import Button from "components/common/button/Button";
import { useContext, useState } from "react";	
import { getAppContext } from 'config/AppContext';
import { NotificationType } from "types/notification-type";

const DemoNotification = () => {
    const context = getAppContext(useContext);
    const [counter, setCounter] = useState(0);

    const notify = (type: NotificationType) => {
        context.notify(type, 'Message' + counter, "Description description  description  description  description  description   description  description  description  description  description  description  description  description  description")
        setCounter(counter + 1);
    }

    return (
        <div className="grid gap-4 w-max p-4">
            <Button theme="default" title="default" onClick={() => notify('success')} >
                <>open success</>
            </Button>
            <Button theme="default" title="default primary" onClick={() => notify('info')} >
                <>open info</>
            </Button>
            <Button theme="default" title="link" onClick={() => notify('error')} >
                <>open error</>
            </Button>
            <Button theme="default" title="link primary" onClick={() => notify('warning')} >
                <>open warning</>
            </Button>
        </div>
    );
};

export default DemoNotification;
